import { defineStore } from 'pinia';
import { useStore } from 'vuex';
import { computed } from 'vue';

export const useUserActionsBridgeStore = defineStore('userActionsBridge', () => {
	const vuex = useStore();

	const qualifications = computed(() => vuex.state.userActions.qualifications);

	const fetchQualifications = () => {
		try {
			return vuex.dispatch('userActions/getQualifications');
		} catch (error) {
			console.log(error);
		}
	};

	return {
		qualifications,
		fetchQualifications,
	};
});
